import accounts from "./accounts";
import account_types from "./account_types";
import account_operators from "./account_operators";
import account_services from "./account_services";
import nominees from "./nominees";
import account_joint from "./account_joint";
import account_atms from "./account_atms";
import term_deposits from "./term_deposits";
import td_schedule from "./td_schedule";
import recurring_deposit from "./recurring_deposit";
import rd_schedule from "./rd_schedule";
import ac_loan_infos from "./ac_loan_infos";
import account_guarantors from "./account_guarantors";
import account_insurances from "./account_insurances";
import account_gold_details from "./account_gold_details";
import account_vehicle_details from "./account_vehicle_details";
import account_house_details from "./account_house_details";
import account_liens from "./account_liens";
import account_securities from "./account_securities";
import account_actions from "./account_actions";
import account_documents from "./account_documents";
import customer_kycs from "./customer_kycs";
import customer_aadhaar_links from "./customer_aadhaar_links";
import members from "./members";
import share_transaction_types from "./share_transaction_types";
import share_transactions from "./share_transactions";
import dividend_payout_methods from "./dividend_payout_methods";
import share_types from "./share_types";
import member_types from "./member_types";
import inddet from "./inddet";
import genders from "./genders";
import marital_statuses from "./marital_statuses";
import instdet from "./instdet";
import indtype from "./indtype";
import customer_types from "./customer_types";
import customer_kpis from "./customer_kpis";
import customer_categories from "./customer_categories";
import customer_documents from "./customer_documents";
import farms from "./farms";
import crops from "./crops";
import sub_crops from "./sub_crops";
import crop_types from "./crop_types";
import soil_types from "./soil_types";
import water_types from "./water_types";
import land_types from "./land_types";
import hangams from "./hangams";
import units from "./units";
import farm_actions from "./farm_actions";
import seasons from "./seasons";
import season_rates from "./season_rates";
import crop_grades from "./crop_grades";
import farm_industries from "./farm_industries";
import agri_purposes from "./agri_purposes";
import agri_domains from "./agri_domains";
import tr001 from "./tr001";
import tr002 from "./tr002";
import bank from "./bank";
import ahwals from "./ahwals";
import villages from "./villages";
import talukas from "./talukas";
import districts from "./districts";
import states from "./states";
import countries from "./countries";
import loan_health_types from "./loan_health_types";
import languages from "./languages";
import nri_types from "./nri_types";
import religions from "./religions";
import castes from "./castes";
import subcastes from "./subcastes";
import file_extentions from "./file_extentions";
import blood_groups from "./blood_groups";
import statuses from "./statuses";
import freeze_types from "./freeze_types";
import modop from "./modop";
import loan_sanctioner_types from "./loan_sanctioner_types";
import loan_referrer_types from "./loan_referrer_types";
import loan_weaker_types from "./loan_weaker_types";
import transaction_types from "./transaction_types";
import instrument_types from "./instrument_types";
import installment_types from "./installment_types";
import installment_freqs from "./installment_freqs";
import installment_frequency_types from "./installment_frequency_types";
import occupations from "./occupations";
import tags from "./tags";
import income_groups from "./income_groups";
import relations from "./relations";
import closenesses from "./closenesses";
import reasons from "./reasons";
import purposes from "./purposes";
import priority_sectors from "./priority_sectors";
import priorities from "./priorities";
import interest_types from "./interest_types";
import interest_on_types from "./interest_on_types";
import interest_separate_types from "./interest_separate_types";
import market_segments from "./market_segments";
import items from "./items";
import fius from "./fius";
import clearings from "./clearings";
import clearing_zones from "./clearing_zones";
import loan_categories from "./loan_categories";
import industry_types from "./industry_types";
import sectors from "./sectors";
import insurance_companies from "./insurance_companies";
import vendors from "./vendors";
import address from "./address";
import titles from "./titles";
import voucher_types from "./voucher_types";
import insurance_types from "./insurance_types";
import insurance_agents from "./insurance_agents";
import gold_ornament_types from "./gold_ornament_types";
import distribution_channel_types from "./distribution_channel_types";
import house_types from "./house_types";
import vehicle_types from "./vehicle_types";
import vehicle_brands from "./vehicle_brands";
import vehicle_models from "./vehicle_models";
import securities from "./securities";
import security_types from "./security_types";
import actions from "./actions";
import metro_types from "./metro_types";
import regions from "./regions";
import region_types from "./region_types";
import updates from "./updates";
import schedules from "./schedules";
import limit_types from "./limit_types";
import date_shortcuts from "./date_shortcuts";
import designations from "./designations";
import departments from "./departments";
import domiciles from "./domiciles";
import risk_categories from "./risk_categories";
import joint_types from "./joint_types";
import cibil_ac_types from "./cibil_ac_types";
import report_groups from "./report_groups";
import report_group_datas from "./report_group_datas";
import delivery_channels from "./delivery_channels";
import holidays from "./holidays";
import branch_types from "./branch_types";
import document_types from "./document_types";
import document_purposes from "./document_purposes";
import gls from "./gls";
import gl_parameters from "./gl_parameters";
import gl_balances from "./gl_balances";
import gl_daily_balances from "./gl_daily_balances";
import gl_tags from "./gl_tags";
import banks from "./banks";
import directors from "./directors";
import hr15 from "./hr15";
import interest_structures from "./interest_structures";
import interest_rates from "./interest_rates";
import demographies from "./demographies";
import interest_calculation_types from "./interest_calculation_types";
import interest_frequencies from "./interest_frequencies";
import products from "./products";
import schemes from "./schemes";
import scheme_services from "./scheme_services";
import product_services from "./product_services";
import product_tags from "./product_tags";
import product_types from "./product_types";
import product_groups from "./product_groups";
import product_loans from "./product_loans";
import product_deposits from "./product_deposits";
import societies from "./societies";
import users from "./users";
import userroles from "./userroles";
import roles from "./roles";
import limits from "./limits";
import forms from "./forms";
import valuators from "./valuators";
import service_groups from "./service_groups";
import group_services from "./group_services";
import services from "./services";
import service_charges from "./service_charges";
import service_taxes from "./service_taxes";
import service_costs from "./service_costs";
import service_commissions from "./service_commissions";
import taxes from "./taxes";
import costs from "./costs";
import commissions from "./commissions";
import service_levels from "./service_levels";
import service_frequencies from "./service_frequencies";
import hsns from "./hsns";
import number_formats from "./number_formats";
import number_format_rules from "./number_format_rules";
import workflows from "./workflows";
import workflow_rules from "./workflow_rules";
import workflow_rule_notices from "./workflow_rule_notices";
import notification_channels from "./notification_channels";
import denomination_details from "./denomination_details";
import currencies from "./currencies";
import crb from "./crb";
import crpts from "./crpts";
import cpb from "./cpb";
import cpbts from "./cpbts";
import portal_pages from "./portal_pages";
import editor from "./editor";
import css_styles from "./css_styles";
import css_style_footers from "./css_style_footers";
import css_props from "./css_props";
import comparators from "./comparators";
import data_sources from "./data_sources";
import report_field_types from "./report_field_types";
import queries from "./queries";
import query_types from "./query_types";
import query_groups from "./query_groups";
import query_group_datas from "./query_group_datas";
import migration_queries from "./migration_queries";
import migration_maps from "./migration_maps";
import migration_map_rules from "./migration_map_rules";
import shares from "./shares";
import customers from "./customers";
import rbi_mis_nos from "./rbi_mis_nos";
import branches from "./branches";
import groups from "./groups";
import group_types from "./group_types";
import group_items from "./group_items";
import acp_loans from "./acp_loans";
import pacs_manual_recoveries from "./pacs_manual_recoveries";
import outstanding_caste_loans from "./outstanding_caste_loans";
import disbursed_caste_loans from "./disbursed_caste_loans";
import atm_card_diss from "./atm_card_diss";
import bulk_report_items from "./bulk_report_items";
import bulk_reports from "./bulk_reports";
import report_types from "./report_types";
import login_histories from "./login_histories";
import oro_clients from "./oro_clients";
import bio_enrolment_types from "./bio_enrolment_types";
import bio_enrolments from "./bio_enrolments";
import member_loan_requests from "./member_loan_requests";
import notf from "./notf";
import bank_pacs_parameters from "./bank_pacs_parameters";
import loan_renew_types from "./loan_renew_types";
import bank_loan_policies from "./bank_loan_policies";
import farmer_shares from "./farmer_shares";
import customer_relations from "./customer_relations";
import ncls from "./ncls";
import renewal_types from "./renewal_types";
import bank_insurances from "./bank_insurances";
import password_policies from "./password_policies";
import servers from "./servers";
import bank_cbs_settings from "./bank_cbs_settings";
import bank_internal_settings from "./bank_internal_settings";
import bank_farmer_settings from "./bank_farmer_settings";
import bank_districts from "./bank_districts";
import agri_ledgers from "./agri_ledgers";
import imcls from "./imcls";
import agri_loan_applications from "./agri_loan_applications";
import inventory_items from "./inventory_items";
import requisitions from "./requisitions";
import quotations from "./quotations";
import board_approvals from "./board_approvals";
import purchase_orders from "./purchase_orders";
import challans from "./challans";
import payment_releases from "./payment_releases";
import credit_notes from "./credit_notes";
import vaults from "./vaults";
import user_targets from "./user_targets";
import targets from "./targets";
import error_types from "./error_types";
import errors from "./errors";
import error_logs from "./error_logs";
import agri_transaction_types from "./agri_transaction_types";
import validate_accounts from "./validate_accounts";
import upload_trial_balances from "./upload_trial_balances";
import clients from "./clients";
import reports from "./reports";
import report_acceptances from "./report_acceptances";
import report_verifications from "./report_verifications";
import upload_dbtls from "./upload_dbtls";
import upload_pacs_statics from "./upload_pacs_statics";
import upload_pacs_otss from "./upload_pacs_otss";
import assign_auditors from "./assign_auditors";
import cash_verifications from "./cash_verifications";
import cash_observations from "./cash_observations";
import cash_observation_types from "./cash_observation_types";
import inspection_statuses from "./inspection_statuses";
import cash_2verifications from "./cash_2verifications";
import cash_2observations from "./cash_2observations";
import reconcilliation_and_balances from "./reconcilliation_and_balances";
import cheques_and_bills from "./cheques_and_bills";
import manual_inspections from "./manual_inspections";
import general_inspections from "./general_inspections";
import loan_inspections from "./loan_inspections";
import npa_inspections from "./npa_inspections";
import npai_observations from "./npai_observations";
import cnb_observations from "./cnb_observations";
import rnb_observation_types from "./rnb_observation_types";
import npai_observation_types from "./npai_observation_types";
import li_observation_types from "./li_observation_types";
import gi_observation_types from "./gi_observation_types";
import cnb_observation_types from "./cnb_observation_types";
import mi_observation_types from "./mi_observation_types";
import rnb_observations from "./rnb_observations";
import deposit_inspections from "./deposit_inspections";
import depositi_observation_types from "./depositi_observation_types";
import feedbacks from "./feedbacks";
import inspection_observation_types from "./inspection_observation_types";
import inspection_types from "./inspection_types";
import inspections from "./inspections";
import loan_account_inspections from "./loan_account_inspections";
import deposit_account_inspections from "./deposit_account_inspections";
import inspection_observations from "./inspection_observations";
import assign_talathis from "./assign_talathis";
import calamity_fund_uploads from "./calamity_fund_uploads";
import calamity_fund_transactions from "./calamity_fund_transactions";
import acceptances from "./acceptances";
import acceptance_statuses from "./acceptance_statuses";
import widgets from "./widgets";
import widget_types from "./widget_types";
import dashboards from "./dashboards";
import widget_labels from "./widget_labels";
import widget_menus from "./widget_menus";
import modules from "./modules";
import user_modules from "./user_modules";
import portals from "./portals";
import talathi_approvals from "./talathi_approvals";
import sajjas from "./sajjas";
import bulk_user_requests from "./bulk_user_requests";
import bulk_message_requests from "./bulk_message_requests";
import sent_messages from "./sent_messages";
import message_delivery_channels from "./message_delivery_channels";
import message_templates from "./message_templates";
import message_template_types from "./message_template_types";
import update_cf_batch_numbers from "./update_cf_batch_numbers";
import revalidate_accounts_from_lagacys from "./revalidate_accounts_from_lagacys";
import rerun_cf_ac_validations from "./rerun_cf_ac_validations";
import portal_schemes from "./portal_schemes";
import assign_portal_to_talathis from "./assign_portal_to_talathis";
import addresses from "./addresses";
import pigmy_deposit from "./pigmy_deposit";
import account_installments from "./account_installments";
import account_installment_schedules from "./account_installment_schedules";
import assign_village_to_branches from "./assign_village_to_branches";
import authentication_types from "./authentication_types";
import banks_local_masters from "./banks_local_masters";
import branches_local_masters from "./branches_local_masters";
import acceptance_status_local_masters from "./acceptance_status_local_masters";
import acceptance_statuses_local_masters from "./acceptance_statuses_local_masters";
import portals_local_masters from "./portals_local_masters";
import portal_schemes_local_masters from "./portal_schemes_local_masters";
import roles_local_masters from "./roles_local_masters";
import copy_client_starter_datas from "./copy_client_starter_datas";
import talukas_local_masters from "./talukas_local_masters";
import append_calamity_fund_transactions from "./append_calamity_fund_transactions";
import inspection_masters from "./inspection_masters";
import financial_years from "./financial_years";
import financial_years_local_masters from "./financial_years_local_masters";
import day_begins from "./day_begins";
import day_ends from "./day_ends";
import day_end_branches from "./day_end_branches";
import bank_suggestion_talathis from "./bank_suggestion_talathis";
import cash_receipt_transactions from "./cash_receipt_transactions";
import cash_receipt_batches from "./cash_receipt_batches";
import account_chequebooks from "./account_chequebooks";
import account_pmsbys from "./account_pmsbys";
import account_pmjjbys from "./account_pmjjbys";
import account_apys from "./account_apys";
import product_parameters from "./product_parameters";
import manual_report_masters from "./manual_report_masters";
import manual_report_types from "./manual_report_types";
import assign_manual_reports from "./assign_manual_reports";
import manual_reports from "./manual_reports";
import manual_report_observations from "./manual_report_observations";
import manual_report_observation_types from "./manual_report_observation_types";
import role_form_groups from "./role_form_groups";
import form_groups from "./form_groups";
import form_types from "./form_types";
import cash_payment_batches from "./cash_payment_batches";
import transfer_batches from "./transfer_batches";
import manual_report_masters_local_masters from "./manual_report_masters_local_masters";
import manual_report_observation_types_local_masters from "./manual_report_observation_types_local_masters";
import transfer_transactions from "./transfer_transactions";
import cash_payment_transactions from "./cash_payment_transactions";
import manual_report_groups from "./manual_report_groups";
import reconcile_cf_wrong_paids from "./reconcile_cf_wrong_paids";
import report_season_formats from "./report_season_formats";
import slbc_aadhaar_authentications from "./slbc_aadhaar_authentications";
import slbc_blocks from "./slbc_blocks";
import slbc_blocks_local_masters from "./slbc_blocks_local_masters";
import slbc_investment_credit_outstandings from "./slbc_investment_credit_outstandings";
import slbc_acp_npa_outstandings from "./slbc_acp_npa_outstandings";
import inspection_masters_local_masters from "./inspection_masters_local_masters";
import hard_deletes from "./hard_deletes";
import apex_societies from "./apex_societies";
import process_bulk_remittances from "./process_bulk_remittances";
import update_cf_batch_number_footers from "./update_cf_batch_number_footers";
import manual_report_observation_cas from "./manual_report_observation_cas";
import employees from "./employees";
import billing_account_details from "./billing_account_details";
import employment_types from "./employment_types";
import daily_attendances from "./daily_attendances";
import mark_leave_requests from "./mark_leave_requests";
import tests from "./tests";
import issue_statuses from "./issue_statuses";
import issues from "./issues";
import assign_issues from "./assign_issues";
import issue_progresses from "./issue_progresses";
import test2 from "./test2";
import recompliances from "./recompliances";
import other_inspections from "./other_inspections";
import employment_grades from "./employment_grades";
import leave_encashment_types_local_masters from "./leave_encashment_types_local_masters";
import leave_types_local_masters from "./leave_types_local_masters";
import employment_grades_local_masters from "./employment_grades_local_masters";
import employment_types_local_masters from "./employment_types_local_masters";
import ifscs_local_masters from "./ifscs_local_masters";
import manual_report_groups_local_masters from "./manual_report_groups_local_masters";
import user_roles from "./user_roles";
import epics from "./epics";
import milestones from "./milestones";
import discussions from "./discussions";
import comments from "./comments";
import storys from "./storys";
import sprints from "./sprints";
import story_issues from "./story_issues";
import sprint_storys from "./sprint_storys";
import work_statuses from "./work_statuses";
import apb_files from "./apb_files";
import apb_file_records from "./apb_file_records";
import issue_types from "./issue_types";
import client_onboardings from "./client_onboardings";
import customer_types_local_masters from "./customer_types_local_masters";
import titles_local_masters from "./titles_local_masters";
import blood_groups_local_masters from "./blood_groups_local_masters";
import relations_local_masters from "./relations_local_masters";
import marital_statuses_local_masters from "./marital_statuses_local_masters";
import genders_local_masters from "./genders_local_masters";
import dows_local_masters from "./dows_local_masters";
import voucher_types_local_masters from "./voucher_types_local_masters";
import vehicle_types_local_masters from "./vehicle_types_local_masters";
import vehicle_brands_local_masters from "./vehicle_brands_local_masters";
import vehicle_models_local_masters from "./vehicle_models_local_masters";
import metro_types_local_masters from "./metro_types_local_masters";
import clearings_local_masters from "./clearings_local_masters";
import instrument_types_local_masters from "./instrument_types_local_masters";
import freeze_types_local_masters from "./freeze_types_local_masters";
import account_statuses_local_masters from "./account_statuses_local_masters";
import installment_types_local_masters from "./installment_types_local_masters";
import installment_frequencies_local_masters from "./installment_frequencies_local_masters";
import interest_on_types_local_masters from "./interest_on_types_local_masters";
import risk_categories_local_masters from "./risk_categories_local_masters";
import document_purposes_local_masters from "./document_purposes_local_masters";
import mode_of_operations_local_masters from "./mode_of_operations_local_masters";
import employee_leaves from "./employee_leaves";
import employee_leave_balances from "./employee_leave_balances";
import generate_salarys from "./generate_salarys";
import salary_trials from "./salary_trials";
import post_salarys from "./post_salarys";
import salarys from "./salarys";
import employment_statues from "./employment_statues";
import leave_types from "./leave_types";
import child_migration_statues from "./child_migration_statues";
import area_types from "./area_types";
import child_statues from "./child_statues";
import track_the_girl_childs from "./track_the_girl_childs";
import assign_sevikas_to_villages from "./assign_sevikas_to_villages";
import pay_scales from "./pay_scales";
import banks_loans from "./banks_loans";
import ifscs from "./ifscs";
import probable_matches from "./probable_matches";
import find_matching_records from "./find_matching_records";
import upload_saral_datas from "./upload_saral_datas";
import schools from "./schools";
import assign_schools_to_users from './assign_schools_to_users'
import matchings from "./matchings";
//import Dailyreports from "./Dailyreports";
//import tgc_taluka_bar from "./tgc_taluka_bar";
import not_match_logs from "./not_match_logs";
export default {
  not_match_logs,
  //tgc_taluka_bar,
  //...Dailyreports,

  schools,
  upload_saral_datas,
  find_matching_records,
  probable_matches,
  matchings,
  assign_schools_to_users,
  ifscs,
  banks_loans,
  pay_scales,
  assign_sevikas_to_villages,
  track_the_girl_childs,
  child_statues,
  area_types,
  child_migration_statues,
  leave_types,
  employment_statues,
  salarys,
  post_salarys,
  salary_trials,
  generate_salarys,
  employee_leave_balances,
  employee_leaves,
  mode_of_operations_local_masters,
  document_purposes_local_masters,
  risk_categories_local_masters,
  interest_on_types_local_masters,
  installment_frequencies_local_masters,
  installment_types_local_masters,
  account_statuses_local_masters,
  freeze_types_local_masters,
  instrument_types_local_masters,
  clearings_local_masters,
  metro_types_local_masters,
  vehicle_models_local_masters,
  vehicle_brands_local_masters,
  vehicle_types_local_masters,
  voucher_types_local_masters,
  dows_local_masters,
  genders_local_masters,
  marital_statuses_local_masters,
  relations_local_masters,
  blood_groups_local_masters,
  titles_local_masters,
  customer_types_local_masters,
  client_onboardings,
  issue_types,
  apb_file_records,
  apb_files,
  work_statuses,
  sprint_storys,
  story_issues,
  sprints,
  storys,
  comments,
  discussions,
  milestones,
  epics,
  user_roles,
  manual_report_groups_local_masters,
  ifscs_local_masters,
  employment_types_local_masters,
  employment_grades_local_masters,
  leave_types_local_masters,
  leave_encashment_types_local_masters,
  employment_grades,
  other_inspections,
  mark_leave_requests,
  daily_attendances,
  employment_types,
  billing_account_details,
  employees,

  recompliances,
  test2,
  issue_progresses,
  assign_issues,
  issues,
  issue_statuses,
  tests,
  manual_report_observation_cas,
  update_cf_batch_number_footers,
  process_bulk_remittances,
  apex_societies,
  hard_deletes,
  inspection_masters_local_masters,
  slbc_acp_npa_outstandings,
  slbc_investment_credit_outstandings,
  slbc_blocks_local_masters,
  slbc_blocks,
  slbc_aadhaar_authentications,
  report_season_formats,
  reconcile_cf_wrong_paids,
  manual_report_groups,
  cash_payment_transactions,
  transfer_transactions,
  manual_report_observation_types_local_masters,
  manual_report_masters_local_masters,
  transfer_batches,
  cash_payment_batches,
  form_types,
  form_groups,
  role_form_groups,
  manual_report_observation_types,
  manual_report_observations,
  manual_reports,
  assign_manual_reports,
  manual_report_types,
  manual_report_masters,
  product_parameters,
  account_apys,
  account_pmjjbys,
  account_pmsbys,
  account_chequebooks,
  cash_receipt_batches,
  cash_receipt_transactions,
  bank_suggestion_talathis,
  day_end_branches,
  day_ends,
  day_begins,
  financial_years_local_masters,
  financial_years,
  inspection_masters,
  append_calamity_fund_transactions,
  talukas_local_masters,
  copy_client_starter_datas,
  roles_local_masters,
  portal_schemes_local_masters,
  portals_local_masters,
  acceptance_statuses_local_masters,
  acceptance_status_local_masters,
  branches_local_masters,
  banks_local_masters,
  authentication_types,
  assign_village_to_branches,
  account_installment_schedules,
  account_installments,
  pigmy_deposit,
  addresses,
  assign_portal_to_talathis,
  portal_schemes,
  rerun_cf_ac_validations,
  revalidate_accounts_from_lagacys,
  update_cf_batch_numbers,
  message_template_types,
  message_templates,
  message_delivery_channels,
  sent_messages,
  bulk_message_requests,
  bulk_user_requests,
  sajjas,
  talathi_approvals,
  portals,
  user_modules,
  modules,
  widget_menus,
  widget_labels,
  dashboards,
  widget_types,
  widgets,
  acceptance_statuses,
  acceptances,
  calamity_fund_transactions,
  calamity_fund_uploads,
  assign_talathis,
  inspection_observations,
  deposit_account_inspections,
  loan_account_inspections,
  inspections,
  inspection_types,
  inspection_observation_types,
  feedbacks,
  depositi_observation_types,
  deposit_inspections,
  rnb_observations,
  mi_observation_types,
  cnb_observation_types,
  gi_observation_types,
  li_observation_types,
  npai_observation_types,
  rnb_observation_types,
  cnb_observations,
  npai_observations,
  npa_inspections,
  loan_inspections,
  general_inspections,
  manual_inspections,
  cheques_and_bills,
  reconcilliation_and_balances,
  cash_2observations,
  cash_2verifications,
  inspection_statuses,
  cash_observation_types,
  cash_observations,
  cash_verifications,
  assign_auditors,
  upload_pacs_otss,
  upload_pacs_statics,
  upload_dbtls,
  report_verifications,
  report_acceptances,
  reports,
  clients,
  upload_trial_balances,
  validate_accounts,
  agri_transaction_types,
  error_logs,
  errors,
  error_types,
  targets,
  user_targets,
  vaults,
  credit_notes,
  payment_releases,
  challans,
  purchase_orders,
  board_approvals,
  quotations,
  requisitions,
  inventory_items,
  agri_loan_applications,
  imcls,
  agri_ledgers,
  bank_districts,
  bank_farmer_settings,
  bank_internal_settings,
  bank_cbs_settings,
  servers,
  password_policies,
  bank_insurances,
  renewal_types,
  ncls,
  customer_relations,
  farmer_shares,
  bank_loan_policies,
  loan_renew_types,
  bank_pacs_parameters,
  notf,
  member_loan_requests,
  bio_enrolments,
  bio_enrolment_types,
  oro_clients,
  login_histories,
  report_types,
  bulk_reports,
  bulk_report_items,
  atm_card_diss,
  disbursed_caste_loans,
  outstanding_caste_loans,
  pacs_manual_recoveries,
  acp_loans,
  group_items,
  group_types,
  groups,
  branches,
  rbi_mis_nos,
  customers,
  shares,
  migration_map_rules,
  migration_maps,
  migration_queries,
  query_group_datas,
  query_groups,
  query_types,
  queries,
  report_field_types,
  data_sources,
  comparators,
  css_props,
  css_style_footers,
  css_styles,
  editor,
  portal_pages,
  cpbts,
  cpb,
  crpts,
  crb,
  currencies,
  denomination_details,
  notification_channels,
  workflow_rule_notices,
  workflow_rules,
  workflows,
  number_format_rules,
  number_formats,
  hsns,
  service_frequencies,
  service_levels,
  commissions,
  costs,
  taxes,
  service_commissions,
  service_costs,
  service_taxes,
  service_charges,
  services,
  group_services,
  service_groups,
  valuators,
  forms,
  limits,
  roles,
  userroles,
  users,
  societies,
  product_deposits,
  product_loans,
  product_groups,
  product_types,
  product_tags,
  product_services,
  scheme_services,
  schemes,
  products,
  interest_frequencies,
  interest_calculation_types,
  demographies,
  interest_rates,
  interest_structures,
  hr15,
  directors,
  banks,
  gl_tags,
  gl_daily_balances,
  gl_balances,
  gl_parameters,
  gls,
  document_purposes,
  document_types,
  branch_types,
  holidays,
  delivery_channels,
  report_group_datas,
  report_groups,
  cibil_ac_types,
  joint_types,
  risk_categories,
  domiciles,
  departments,
  designations,
  date_shortcuts,
  limit_types,
  schedules,
  updates,
  region_types,
  regions,
  metro_types,
  actions,
  security_types,
  securities,
  vehicle_models,
  vehicle_brands,
  vehicle_types,
  house_types,
  distribution_channel_types,
  gold_ornament_types,
  insurance_agents,
  insurance_types,
  voucher_types,
  titles,
  address,
  vendors,
  insurance_companies,
  sectors,
  industry_types,
  loan_categories,
  clearing_zones,
  clearings,
  fius,
  items,
  market_segments,
  interest_separate_types,
  interest_on_types,
  interest_types,
  priorities,
  priority_sectors,
  purposes,
  reasons,
  closenesses,
  relations,
  income_groups,
  tags,
  occupations,
  installment_frequency_types,
  installment_freqs,
  installment_types,
  instrument_types,
  transaction_types,
  loan_weaker_types,
  loan_referrer_types,
  loan_sanctioner_types,
  modop,
  freeze_types,
  statuses,
  blood_groups,
  file_extentions,
  subcastes,
  castes,
  religions,
  nri_types,
  languages,
  loan_health_types,
  countries,
  states,
  districts,
  talukas,
  villages,
  ahwals,
  bank,
  tr002,
  tr001,
  agri_domains,
  agri_purposes,
  farm_industries,
  crop_grades,
  season_rates,
  seasons,
  farm_actions,
  units,
  hangams,
  land_types,
  water_types,
  soil_types,
  crop_types,
  sub_crops,
  crops,
  farms,
  customer_documents,
  customer_categories,
  customer_kpis,
  customer_types,
  indtype,
  instdet,
  marital_statuses,
  genders,
  inddet,
  member_types,
  share_types,
  dividend_payout_methods,
  share_transactions,
  share_transaction_types,
  members,
  customer_aadhaar_links,
  customer_kycs,
  account_documents,
  account_actions,
  account_securities,
  account_liens,
  account_house_details,
  account_vehicle_details,
  account_gold_details,
  account_insurances,
  account_guarantors,
  ac_loan_infos,
  rd_schedule,
  recurring_deposit,
  td_schedule,
  term_deposits,
  account_atms,
  account_joint,
  nominees,
  account_services,
  account_operators,
  account_types,
  accounts,
}